const React = require('react');

const { List } = require('@andes/list');

// Just an Andes list wrapper

const ListComponent = (props) => <List {...props} />;

module.exports = ListComponent;
